// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__318o5","upload":"Small_upload__FYpOs","imageWrap":"Small_imageWrap__2pGMr","removeBtn":"Small_removeBtn__21OPM"};